import { Icon } from "@iconify/react/dist/iconify.js";
import "./style.css";
import { useTranslation } from "react-i18next";
import Card from "../../../shared/Card/Card";

const Classification = ({ data }) => {
  const { t } = useTranslation();
  const { requestData, patientData} = data || {};
  const cardClasses = "classification-card border-0 box-shadow ";
  return (
    <div className=" mt-4 classification-container">
      <Card icon="hugeicons:stethoscope" title={t("medical-category")} value={requestData?.category} className={`${cardClasses} section bg-white`} />
      <Card icon="solar:medical-kit-outline" title={t("sub-category")} value={requestData?.subCategory} className={`${cardClasses} section bg-white`} />
      <Card icon="solar:file-check-outline" title={t("requested-service")} value={requestData?.medicalDiagnosis} className={`${cardClasses} section bg-white`} />
      
      <Card className={cardClasses}>
        <p className="title service-title text-uppercase">{t("service-window")}</p>
        <div className="service-row mt-2">
          <span className="service-label">{t("start")}:</span>
          <span className="service-value">{requestData?.startDate}</span>
        </div>
        <div className="service-row">
          <span className="service-label">{t("end")}:</span>
          <span className="service-value">{requestData?.endDate}</span>
        </div>
      </Card>
    </div>
  );
};

export default Classification;

const Section = ({ icon, title, value }) => {
  return (
    <div className="section bg-white">
      <div className="icon-container">
        <Icon icon={icon} className="icon" />
      </div>
      <div className="d-flex flex-column gap-1 justify-content-center">
        <p className="title text-uppercase">{title}</p>
        <p className="value">{value}</p>
      </div>
    </div>
  );
};
